import RenderManager from "../rendering/render-manager";

function addProtection() {
    let selected = null, isTransitioning = false;
    let selectingMesh = false;
    let controls = null;

    Object.defineProperties(Q3, {
        controls: {
            get: () => controls,
            set: v => controls = v
        },
        selected: {
            get: () => selected,
            set: value => {
                if (value === selected || (value && value.isUnselectable)) return;
                if (selected && (selected.type2d === "CustomizableRegion" || selected.type2d === "Graphing")) {
                    if (selected.editing) selected.editing = false;
                }

                if (Q3.isAssetMode) {
                    function setLabelDemand(object, value) {
                        object.traverse(object => {
                            if (!object.isMesh || !(object.uuid in Q3.data.assets.objects)) return;

                            const meshLabel = Q3.labels.live.getMeshLabel(object);

                            if (!meshLabel) return;

                            const uuid = meshLabel.uuid;
                            const liveLabel = Q3.labels.live.getLabelByUuid(uuid);

                            liveLabel.isDemandLabel = value;
                        });
                    }

                    if (selected && selected.isObject3D) setLabelDemand(selected, false);
                    if (value && value.isObject3D) setLabelDemand(value, true);
                }

                Q3.labels.live.clearSelectedRegion();


                selected = value;
                if (value && value instanceof THREE.Object3D)
                    RenderManager.setOutlineObjects([selected]);
                else RenderManager.setOutlineObjects([]);
            }
        },
        isTransitioning: {
            get: () => isTransitioning,
            set: value => isTransitioning = value

        },
        selectingMesh: {
            get: () => selectingMesh,
            set: value => {
                selectingMesh = value;
            }
        }
    });
};

function addPostProtection() {
    let shouldUpdateCamera = false;

    Object.defineProperties(RenderManager.activeCamera, {
        update: {
            get: () => shouldUpdateCamera,
            set: val => shouldUpdateCamera = val

        }
    });

    // Q3.data.slides.forEach(({ animation }) => {
    //     Object.values(animation).forEach(animation => {
    //         const position = animation.position;
    //         const rotation = animation.rotation;
    //         const scale = animation.scale;

    //         delete animation.position;
    //         delete animation.rotation;
    //         delete animation.scale;

    //         animation.position = {};
    //         animation.rotation = {};
    //         animation.scale = {};

    //         Object.defineProperties(animation.position, {
    //             x: {
    //                 get: () => position.x,
    //                 set: v => position.x = v
    //             },
    //             y: {
    //                 get: () => position.y,
    //                 set: v => position.y = v
    //             },
    //             z: {
    //                 get: () => position.z,
    //                 set: v => position.z = v
    //             }
    //         })
    //         Object.defineProperties(animation.rotation, {
    //             x: {
    //                 get: () => rotation.x,
    //                 set: v => rotation.x = v
    //             },
    //             y: {
    //                 get: () => rotation.y,
    //                 set: v => rotation.y = v
    //             },
    //             z: {
    //                 get: () => rotation.z,
    //                 set: v => rotation.z = v
    //             }
    //         })
    //         Object.defineProperties(animation.scale, {
    //             x: {
    //                 get: () => scale.x,
    //                 set: v => scale.x = v
    //             },
    //             y: {
    //                 get: () => scale.y,
    //                 set: v => scale.y = v
    //             },
    //             z: {
    //                 get: () => scale.z,
    //                 set: v => scale.z = v
    //             }
    //         })
    //     });
    // });
}

function addCameraProtection(camera) {
    let _fov = camera.fov, _aspect = camera.aspect, _near = camera.near, _far = camera.far;
    delete camera.fov;
    delete camera.aspect;
    delete camera.near;
    delete camera.far;

    // protectVector(camera.position);

    Object.defineProperties(camera, {
        aspect: {
            get: () => _aspect,
            set: aspect => _aspect = aspect
        },
        fov: {
            get: () => _fov,
            set: fov => _fov = fov
        },
        near: {
            get: () => _near,
            set: near => _near = near
        },
        far: {
            get: () => _far,
            set: far => _far = far
        }
    });
}

export { addProtection, addPostProtection, addCameraProtection };